import { Alert, Modal, Text, Group, Button } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

export default function ConfirmationModal({
  opened,
  onClose,
  onConfirm,
  pendingToggle,
  warning,
}) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Confirm Feature Toggle"
      centered
    >
      <Text mb="md">
        Are you sure you want to {!pendingToggle ? "enable" : "disable"} this
        feature?
      </Text>
      {warning && (
        <Alert
          color="orange"
          variant="light"
          icon={<IconAlertTriangle />}
          mb="md"
        >
          {warning}
        </Alert>
      )}
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button color="blue" onClick={onConfirm}>
          Confirm
        </Button>
      </Group>
    </Modal>
  );
}
